export default __webpack_public_path__ + "static/deek_smile-c3bf688c8f02ebdfd794e4b87d993efa.png";